module.exports = __webpack_public_path__ + "img/jo1.4b466712.png";